import { render } from "./EventRace.vue?vue&type=template&id=2f7d98b8&scoped=true"
import script from "./EventRace.vue?vue&type=script&lang=js"
export * from "./EventRace.vue?vue&type=script&lang=js"

import "./EventRace.vue?vue&type=style&index=0&id=2f7d98b8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7d98b8"]])

export default __exports__